














































































import Vue from "vue";
import ApiService from "@/services/ApiService";
import { apiUrl } from "@/domain";
import dbConnection from "@/services/dbConnection";

// import OrgSelectionAdmin from "@/components/admin/OrgSelectionAdmin.vue";
export default Vue.extend({
  name: "StepDatamodelModal",
  components: {
    // OrgSelectionAdmin,
  },
  data() {
    return {
      form: {
        name: "",
      },
      loading: false,
      responseInfo: {
      },
      csv_selection: "",
      csv_list: [],
      council_id: 881,
    };
  },
  methods: {
    async submit() {
      const fileInput = this.$refs.file as HTMLInputElement;
      if (!fileInput.files || fileInput.files.length === 0) {
        alert("Please select a file first.");
        return;
      }
      const file = fileInput.files[0];
      this.loading = true;
      try {
        const presignedUrlResponse = await dbConnection.post(
          apiUrl + "/api/admin/step_datamodel/getPresignedUploadUrl",
          {
            name: this.form.name,
            fileName: file.name,
            contentType: file.type,
            section: "step_datamodel",
          }
        );

        const presignedUrl = presignedUrlResponse.data.upload_url;

        const uploadResponse = await fetch(presignedUrl, {
          method: "PUT",
          body: file,
          headers: {
            "Content-Type": file.type,
          },
        });

        if (uploadResponse.status < 200 || uploadResponse.status >= 300) {
          throw new Error(`GCS upload failed: ${uploadResponse.status}`);
        }

        alert("done");
        this.$emit("close");
      } catch (error) {
        // console.error("Upload failed", error);
        alert("Upload failed");
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.$emit("close");
    },
    async copyText(mytext) {
      try {
        await navigator.clipboard.writeText(mytext);
        this.$notify.info({
          title: "Copied",
        });
      } catch ($e) {
        alert("Cannot copy");
      }
    },
    async process_csv() {
      try {
        this.loading = true;
        const response = await dbConnection.post(apiUrl + "/api/admin/step_datamodel/step_action", {
          action: "process_csv",
          csv_selection: this.csv_selection,
        });
        this.$notify.success({
          title: "Success",
          message: "CSV processed successfully",
        });
      } catch (error) {
        console.error(error);
        this.$notify.error({
          title: "Error",
          message: "Failed to process CSV",
        });
      } finally {
        this.loading = false;
      }
    },
    async get_csv_list() {
      try {
        const response = await dbConnection.get(apiUrl + "/api/admin/step_datamodel/get_csv_list");
        this.csv_list = response.data.reverse().map(item => ({
          label: item,
          value: item,
        }));
      } catch (error) {
        console.error(error);
      }
    },
    async stepAction(action) {
      try {
        this.loading = true;
        const response = await dbConnection.post(apiUrl + "/api/admin/step_datamodel/step_action", {
          action: action,
          council_id: this.council_id,
        }, {
          timeout: 0, // no timeout
        });
        this.$notify.success({
          title: "Success",
          message: "Action completed",
        });
      } catch (error) {
        this.$notify.error({
          title: "Error",
          message: "Action failed",
        });
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.get_csv_list();
  },
});
